/* HYBRID: Nova cart drawer disabled — themevua side-cart ( #cart + scripts.js ) is the single source of truth. Nova.js only handles drawers/filters/search/pagination. */
/* NOVA shared engine — cart, drawers, search, quickshop, recently viewed, sticky ATC */
(function(){
  const Nova = window.Nova = {};
  const $ = (s, r=document)=>r.querySelector(s);
  const $$ = (s, r=document)=>[...r.querySelectorAll(s)];

  function fetchJson(url, opts){ return fetch(url, opts).then(r=>r.json()); }

  Nova.toast = function(html){
    let t = $('.nv-toast');
    if(!t){ t=document.createElement('div'); t.className='nv-toast'; document.body.appendChild(t); }
    t.textContent = html; t.classList.add('is-visible'); clearTimeout(t._tm); t._tm=setTimeout(()=>t.classList.remove('is-visible'), 2600);
  };

  Nova.openDrawer = function(name){ const d = document.querySelector(`[data-nv-drawer="${name}"]`); if(d) d.classList.add('is-open'); document.body.style.overflow='hidden'; };
  Nova.closeDrawers = function(){ $$('[data-nv-drawer].is-open,[data-nv-modal].is-open,.nv-search.is-open').forEach(e=>e.classList.remove('is-open')); document.body.style.overflow=''; };
  document.addEventListener('click', e=>{
    const o = e.target.closest('[data-nv-open]'); if(o){ e.preventDefault(); const n=o.getAttribute('data-nv-open'); if(n==='search') document.querySelector('.nv-search')?.classList.add('is-open'); else Nova.openDrawer(n); }
    if(e.target.closest('[data-nv-close]') || e.target.matches('.nv-drawer__overlay,.nv-search__overlay,.nv-modal__overlay')) Nova.closeDrawers();
  });
  document.addEventListener('keydown', e=>{ if(e.key==='Escape') Nova.closeDrawers(); });

  // Cart API
  Nova.cart = {
    add(id, qty=1, props={}){
      const body = { id, quantity: qty };
      if(Object.keys(props).length) body.properties = props;
      return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body)})
        .then(r=>r.json().then(j=>({ok:r.ok, j}))).then(({ok,j})=>{
          if(!ok) throw j;
          Nova.cart.refresh(); Nova.openDrawer('cart'); document.dispatchEvent(new CustomEvent('nova:cart:added',{detail:j}));
          Nova.toast('ADDED TO CART');
          return j;
        }).catch(e=>{ Nova.toast(e.description||'Could not add to cart'); throw e; });
    },
    update(updates){ // updates: {key: qty}
      return fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({updates})}).then(r=>r.json()).then(j=>{ Nova.cart.refresh(); return j; });
    },
    remove(key){ return Nova.cart.update({[key]:0}); },
    refresh(){
      // update counts everywhere
      fetch('/cart.js').then(r=>r.json()).then(cart=>{
        $$('.cart-count,[data-nv-cart-count]').forEach(el=> el.textContent = cart.item_count);
        document.dispatchEvent(new CustomEvent('nova:cart:updated',{detail:cart}));
      });
      // re-render drawer section via Section Rendering API
      const sec = document.getElementById('shopify-section-cart-drawer-nova');
      const url = window.location.pathname + '?sections=cart-drawer-nova';
      // Shopify returns { "cart-drawer-nova": "<html>" } when sections param used; need full fetch with correct param
      fetch('/?sections=cart-drawer-nova').then(r=>r.json()).then(j=>{
        const html = j['cart-drawer-nova'];
        if(html && sec){ const tmp=document.createElement('div'); tmp.innerHTML=html; const fresh=tmp.querySelector('#shopify-section-cart-drawer-nova'); if(fresh) sec.innerHTML = fresh.innerHTML; }
      }).catch(()=>{});
    }
  };

  // Predictive search
  const sInput = $('[data-nv-search-input]');
  const sResults = $('[data-nv-search-results]');
  let sTimer;
  if(sInput && sResults){
    sInput.addEventListener('input', ()=>{
      clearTimeout(sTimer);
      const q = sInput.value.trim();
      if(q.length<2){ sResults.innerHTML='<p class="nv-progress__label">TYPE TO SEARCH — PRODUCTS, COLLECTIONS & LORE</p>'; return; }
      sTimer=setTimeout(()=>{
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,query,article,page&resources[limit]=5&resources[options][fields]=title,product_type,vendor`)
          .then(r=>r.json()).then(data=>{
            const prods = (data.resources?.results?.products)||[];
            const cols = (data.resources?.results?.collections)||[];
            const queries = (data.resources?.results?.queries)||[];
            const pages = (data.resources?.results?.pages)||[];
            const arts = (data.resources?.results?.articles)||[];
            let html='';
            if(queries.length){ html+=`<div class="nv-search__group"><div class="nv-search__label">SUGGESTIONS</div>`+queries.map(q=>`<a class="nv-srow" href="/search?q=${encodeURIComponent(q.text)}">${q.text}</a>`).join('')+`</div>`; }
            if(prods.length){ html+=`<div class="nv-search__group"><div class="nv-search__label">PRODUCTS</div>`+prods.map(p=>`
              <a class="nv-srow" href="${p.url}"><img src="${(p.featured_image?.url||'')} " alt=""><div><div class="nv-srow__title">${p.title}</div><div class="nv-srow__price">${p.price? (p.price/100).toFixed(2):''}</div></div></a>`).join('')+`</div>`; }
            if(cols.length){ html+=`<div class="nv-search__group"><div class="nv-search__label">COLLECTIONS</div>`+cols.map(c=>`<a class="nv-srow" href="${c.url}">${c.title}</a>`).join('')+`</div>`; }
            const more = [...pages, ...arts];
            if(more.length){ html+=`<div class="nv-search__group"><div class="nv-search__label">PAGES & LORE</div>`+more.slice(0,5).map(a=>`<a class="nv-srow" href="${a.url}">${a.title}</a>`).join('')+`</div>`; }
            html+=`<a class="nv-toolbar__btn" href="/search?q=${encodeURIComponent(q)}" style="margin-top:8px;display:inline-block">VIEW ALL RESULTS →</a>`;
            sResults.innerHTML = html || '<p class="nv-progress__label">NO RESULTS</p>';
          }).catch(()=> sResults.innerHTML='<p class="nv-progress__label">SEARCH UNAVAILABLE</p>');
      }, 260);
    });
  }

  // Load more
  document.addEventListener('click', e=>{
    const a = e.target.closest('[data-nv-load-more]');
    if(!a) return;
    e.preventDefault();
    const url = a.getAttribute('href');
    if(!url || a.dataset.loading) return;
    a.dataset.loading='1'; const orig=a.textContent; a.textContent='LOADING…';
    fetch(url).then(r=>r.text()).then(html=>{
      const doc = new DOMParser().parseFromString(html,'text/html');
      const grid = document.querySelector('.grid[data-nv-grid]');
      const nextGrid = doc.querySelector('.grid[data-nv-grid]');
      if(grid && nextGrid){ nextGrid.querySelectorAll('.card').forEach(c=> grid.appendChild(c)); }
      const nextBtn = doc.querySelector('[data-nv-load-more]');
      if(nextBtn) a.setAttribute('href', nextBtn.getAttribute('href')); else a.remove();
      a.textContent=orig; delete a.dataset.loading;
    }).catch(()=>{ a.textContent=orig; delete a.dataset.loading;});
  });

  // Quickshop delegation
  document.addEventListener('click', e=>{
    const btn = e.target.closest('[data-nv-quickshop]');
    if(!btn) return;
    e.preventDefault();
    const handle = btn.getAttribute('data-handle');
    if(!handle) return;
    fetch(`/products/${handle}.js`).then(r=>r.json()).then(p=>{
      let modal = document.querySelector('[data-nv-modal="quickshop"]');
      if(!modal){
        modal=document.createElement('div'); modal.className='nv-modal'; modal.setAttribute('data-nv-modal','quickshop');
        modal.innerHTML='<div class="nv-modal__overlay" data-nv-close></div><div class="nv-modal__panel"><div class="nv-drawer__head"><span class="nv-drawer__title">QUICK ADD</span><button class="nv-drawer__close" data-nv-close>CLOSE</button></div><div class="nv-modal__body" data-nv-qs-body></div></div>';
        document.body.appendChild(modal);
        modal.querySelector('.nv-modal__overlay').addEventListener('click', Nova.closeDrawers);
      }
      const body = modal.querySelector('[data-nv-qs-body]');
      const variants = p.variants||[];
      const hasMulti = variants.length>1;
      const thumb = p.featured_image || '';
      body.innerHTML = `
        <div style="display:grid;grid-template-columns:110px 1fr;gap:14px">
          <img src="${thumb}" style="width:110px;height:110px;object-fit:cover;border:1px solid var(--line);background:var(--bg)">
          <div><div style="font-family:Archivo Black;text-transform:uppercase">${p.title}</div><div class="nv-price" style="margin-top:6px">${p.price_min? (p.price/100).toFixed(2):''}</div></div>
        </div>
        <form data-nv-qs-form style="margin-top:14px">
          ${hasMulti ? `<select name="id" style="width:100%;background:var(--bg);border:1px solid var(--line);color:var(--ink);padding:12px">${variants.map(v=>`<option value="${v.id}" ${v.available?'':'disabled'}>${v.title} — $${(v.price/100).toFixed(2)} ${v.available?'':' (SOLD OUT)'}</option>`).join('')}</select>` : `<input type="hidden" name="id" value="${variants[0]?.id||p.variants[0]?.id}">`}
          <div style="display:flex;gap:10px;margin-top:12px">
            <span class="nv-qty"><button type="button" data-nv-qty="-">−</button><input name="quantity" value="1" min="1"><button type="button" data-nv-qty="+">+</button></span>
            <button class="btn btn--fill" type="submit" style="flex:1">ADD TO CART</button>
          </div>
        </form>`;
      body.querySelectorAll('[data-nv-qty]').forEach(b=> b.addEventListener('click', ()=>{ const inp=body.querySelector('input[name="quantity"]'); let v=parseInt(inp.value||1,10); v+= b.dataset.nvQty==='+'?1:-1; if(v<1) v=1; inp.value=v; }));
      body.querySelector('[data-nv-qs-form]').addEventListener('submit', ev=>{
        ev.preventDefault();
        const fd=new FormData(ev.target); Nova.cart.add(parseInt(fd.get('id'),10), parseInt(fd.get('quantity'),10)).then(()=> Nova.closeDrawers());
      });
      modal.classList.add('is-open'); document.body.style.overflow='hidden';
    });
  });

  // Recently viewed
  (function(){
    const key='nova-recent'; const grid=document.querySelector('[data-nv-recent-grid]');
    const handle=document.body.getAttribute('data-nv-handle');
    if(handle){
      try{ let a=JSON.parse(localStorage.getItem(key)||'[]'); a=a.filter(h=>h!==handle); a.unshift(handle); a=a.slice(0,8); localStorage.setItem(key, JSON.stringify(a)); }catch(e){}
    }
    if(grid){
      const exclude = grid.getAttribute('data-exclude')||'';
      let handles=[]; try{ handles=JSON.parse(localStorage.getItem(key)||'[]'); }catch(e){}
      handles=handles.filter(h=>h!==exclude).slice(0,4);
      if(!handles.length){ const sec=grid.closest('section'); if(sec) sec.style.display='none'; return; }
      Promise.all(handles.map(h=> fetch(`/products/${h}.js`).then(r=>r.json()).catch(()=>null))).then(products=>{
        products=products.filter(Boolean);
        if(!products.length) return;
        grid.innerHTML = products.map(p=>{
          const img=p.featured_image||''; const price=(p.price/100).toFixed(2);
          return `<a class="card" href="/products/${p.handle}"><div class="card__media" style="aspect-ratio:4/5"><img src="${img}" alt="" style="width:100%;height:100%;object-fit:cover"></div><div class="card__body"><div class="card__name">${p.title}</div><div class="card__meta"><span></span><span class="card__price">$${price}</span></div></div></a>`;
        }).join('');
      });
    }
  })();

  // Product form AJAX + variant sync
  document.addEventListener('DOMContentLoaded', ()=>{
    const form=$('[data-nv-form]'); if(!form) return;
    const priceEl=$('[data-nv-price]'); const atcBtn=form.querySelector('[data-nv-atc]');
    const selects = $$('[data-nv-option]', form);
    let productJson=null; try{ productJson=JSON.parse($('#NovaProductJson')?.textContent||'null'); }catch(e){}
    function currentVariant(){
      if(!productJson) return null;
      const vals = selects.map(s=> s.value);
      return productJson.variants.find(v=> v.options.every((o,i)=> o===vals[i])) || null;
    }
    function sync(){
      const v=currentVariant(); if(!v) return;
      if(priceEl){ const m=(v.price/100).toFixed(2); const c=v.compare_at_price? (v.compare_at_price/100).toFixed(2):null;
        priceEl.innerHTML = c && v.compare_at_price>v.price ? `<s>$${c}</s> $${m}` : `$${m}`; }
      const idInput=form.querySelector('input[name="id"]'); if(idInput) idInput.value=v.id;
      if(atcBtn){ atcBtn.disabled=!v.available; atcBtn.textContent = v.available ? 'ADD TO CART' : 'SOLD OUT'; }
      // gallery sync: if variant featured image exists, swap main
      const mainImg=$('[data-nv-main-image]'); if(mainImg && v.featured_image?.src){ mainImg.src=v.featured_image.src; }
    }
    selects.forEach(s=> s.addEventListener('change', ()=>{ const idx=s.getAttribute('data-option-index'); const lbl=document.querySelector(`[data-nv-option-label="${parseInt(idx,10)+1}"]`); if(lbl) lbl.textContent='— '+s.value; sync(); })); sync();
    // swatch / pill buttons -> update hidden select
    document.addEventListener('click', e=>{
      const sw=e.target.closest('[data-nv-swatch]'); if(sw){
        const idx=sw.getAttribute('data-option-index'); const val=sw.getAttribute('data-value');
        const sel=document.querySelector(`select[data-nv-option][data-option-index="${idx}"]`); if(sel){ sel.value=val; sel.dispatchEvent(new Event('change',{bubbles:true})); }
        sw.closest('[data-nv-swatches]')?.querySelectorAll('[data-nv-swatch]').forEach(b=> b.classList.toggle('is-active', b===sw));
      }
      const pill=e.target.closest('[data-nv-pill]'); if(pill){
        const idx=pill.getAttribute('data-option-index'); const val=pill.getAttribute('data-value');
        const sel=document.querySelector(`select[data-nv-option][data-option-index="${idx}"]`); if(sel){ sel.value=val; sel.dispatchEvent(new Event('change',{bubbles:true})); }
        pill.closest('[data-nv-pills]')?.querySelectorAll('[data-nv-pill]').forEach(b=> b.classList.toggle('is-active', b===pill));
      }
    });
    form.addEventListener('submit', e=>{
      e.preventDefault();
      const fd=new FormData(form); const id=parseInt(fd.get('id'),10); const qty=parseInt(fd.get('quantity')||1,10);
      Nova.cart.add(id, qty).then(()=>{});
    });
    // gallery thumbs
    $$('[data-nv-thumb]').forEach(b=> b.addEventListener('click', ()=>{ const src=b.getAttribute('data-src'); const main=$('[data-nv-main-image]'); if(src&&main) main.src=src; $$('[data-nv-thumb]').forEach(x=>x.classList.remove('is-active')); b.classList.add('is-active'); }));
  });

  // Sticky ATC visibility
  (function(){
    const bar=$('[data-nv-sticky-atc]'); const buybox=$('[data-nv-buybox]'); if(!bar||!buybox) return;
    const obs=new IntersectionObserver(entries=>{
      const e=entries[0]; if(e.isIntersecting) bar.classList.remove('is-visible'); else bar.classList.add('is-visible');
    }, {threshold:0});
    obs.observe(buybox);
  })();

  // Countdown
  $$('[data-nv-countdown]').forEach(el=>{
    const until=new Date(el.getAttribute('data-until')).getTime();
    function tick(){
      const d=Math.max(0, until - Date.now());
      const h=Math.floor(d/3600000), m=Math.floor(d%3600000/60000), s=Math.floor(d%60000/1000);
      el.textContent = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
      if(d>0) requestAnimationFrame(()=> setTimeout(tick, 1000)); else el.textContent='00:00:00';
    }
    tick();
  });

  // Back to top
  const topBtn=$('[data-nv-top]'); if(topBtn){ topBtn.addEventListener('click', ()=> window.scrollTo({top:0, behavior:'smooth'})); window.addEventListener('scroll', ()=>{ topBtn.style.display = window.scrollY>400 ? 'grid':'none'; }, {passive:true}); }

  // Cart qty + remove delegation (drawer + cart page)
  document.addEventListener('click', e=>{
    const q=e.target.closest('[data-nv-qty]'); if(q){
      const inp=q.parentElement.querySelector('input'); if(!inp) return;
      const step=parseInt(inp.getAttribute('step')||1,10); let v=parseInt(inp.value||1,10); v+= q.dataset.nvQty==='+'? step : -step;
      const min=parseInt(inp.getAttribute('min')||1,10); const max=inp.getAttribute('max')? parseInt(inp.getAttribute('max'),10): Infinity;
      if(v<min) v=min; if(v>max) v=max; inp.value=v; inp.dispatchEvent(new Event('change',{bubbles:true}));
      return;
    }
    const rm=e.target.closest('[data-nv-remove]'); if(rm){
      e.preventDefault(); const key=rm.getAttribute('data-key')||rm.getAttribute('data-line'); // key for Section API is line item key
      // Try cart.js key removal: fetch /cart/change.js with line + quantity 0
      const line=parseInt(rm.getAttribute('data-line')||0,10);
      if(line){ fetch('/cart/change.js',{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({line, quantity:0})}).then(()=> Nova.cart.refresh()); }
      else if(key){ Nova.cart.remove(key); }
    }
  });
  document.addEventListener('change', e=>{
    if(e.target.matches('[data-nv-update]')){
      const key=e.target.getAttribute('data-key'); const line=e.target.getAttribute('data-line'); const qty=parseInt(e.target.value||0,10);
      if(line) fetch('/cart/change.js',{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({line:parseInt(line,10), quantity:qty})}).then(()=> Nova.cart.refresh());
      else if(key) Nova.cart.update({[key]:qty});
    }
  });

  // Recommendations fetch
  const recWrap=document.querySelector('[data-nv-recommendations]'); if(recWrap){
    const url=recWrap.getAttribute('data-url'); if(url) fetch(url).then(r=>r.text()).then(html=>{
      const doc=new DOMParser().parseFromString(html,'text/html'); const fresh=doc.querySelector('[data-nv-recommendations]'); if(fresh && fresh.innerHTML.trim()) recWrap.innerHTML=fresh.innerHTML;
      else recWrap.closest('section')?.remove();
    });
  }
})();
